import { API } from "../../../beans";

export enum MyzTokenUserActionEnum {
  REQUEST = "app/MYZTOKENUSER/REQUEST",
  SUCCESS = "app/MYZTOKENUSER/SUCCESS",
  FAIL = "app/MYZTOKENUSER/FAIL",
}

export interface IMyzTokenUserRequest {
  type: MyzTokenUserActionEnum.REQUEST;
}
export interface IMyzTokenUserSuccess {
  type: MyzTokenUserActionEnum.SUCCESS;
  data: API.MyzTokenUser;
}
export interface IMyzTokenUserFail {
  type: MyzTokenUserActionEnum.FAIL;
  err: Error;
}

export type MyzTokenUserAction =
  | IMyzTokenUserRequest
  | IMyzTokenUserSuccess
  | IMyzTokenUserFail;

export function myzTokenUserRequest(): IMyzTokenUserRequest {
  return {
    type: MyzTokenUserActionEnum.REQUEST,
  };
}
export function myzTokenUserSuccess(
  data: API.MyzTokenUser,
): IMyzTokenUserSuccess {
  return {
    type: MyzTokenUserActionEnum.SUCCESS,
    data,
  };
}
export function myzTokenUserFail(err: Error): IMyzTokenUserFail {
  return {
    type: MyzTokenUserActionEnum.FAIL,
    err,
  };
}
